export default __webpack_public_path__ + "static/media/Menu.73762473.svg";